export default "__VITE_ASSET__a0c04ad4__"